import { CheckCircle2 } from 'lucide-react';
import { Card } from '@/shared/ui/card';

interface PublicInviteDuplicateProps {
  email: string;
}

/** Equivalente a views/invite_resend.ejs — "já existe cadastro", reenvio silencioso do cartão. */
export function PublicInviteDuplicate({ email }: PublicInviteDuplicateProps) {
  return (
    <Card className="mx-auto max-w-md p-8 text-center">
      <CheckCircle2 className="mx-auto size-12 text-success" />
      <h1 className="mt-4 text-xl font-semibold">Você já tem cadastro</h1>
      <p className="mt-2 text-sm text-muted-foreground">
        Já existe um cadastro para os dados informados.
        {email ? (
          <>
            {' '}
            Enviamos o cartão para o e-mail <b>{email}</b>.
          </>
        ) : null}
      </p>
    </Card>
  );
}
